import { UserOnboardingDepartment, UserOnboardingJobLevel, UserSource, UserTheme } from "@supernova-studio/model";
import { z } from "zod";
import { DTOUser, DTOUserProfile } from "./user";

export const DTOUserOnboardingDepartment = UserOnboardingDepartment;
export const DTOUserOnboardingJobLevel = UserOnboardingJobLevel;
export const DTOUserSource = UserSource;
export const DTOUserTheme = UserTheme;

export const DTOUserOnboarding = z.object({
  companyName: z.string().optional(),
  numberOfPeopleInOrg: z.string().optional(),
  numberOfPeopleInDesignTeam: z.string().optional(),
  department: DTOUserOnboardingDepartment.optional(),
  jobTitle: z.string().optional(),
  phase: z.string().optional(),
  jobLevel: DTOUserOnboardingJobLevel.optional(),
  designSystemName: z.string().optional(),
  defaultDestination: z.string().optional(),
  isPageDraftOnboardingFinished: z.boolean().optional(),
});

export const DTOAuthenticatedUserProfile = DTOUserProfile.extend({
  onboarding: DTOUserOnboarding.optional(),
  theme: DTOUserTheme.optional(),
});

export const DTOAuthenticatedUser = DTOUser.extend({
  profile: DTOAuthenticatedUserProfile,
  createdAt: z.coerce.date(),
  loggedOutAt: z.coerce.date().optional(),
  source: DTOUserSource.optional(),
});

export const DTOAuthenticatedUserResponse = z.object({
  user: DTOAuthenticatedUser,
});

export type DTOUserOnboardingDepartment = z.infer<typeof DTOUserOnboardingDepartment>;
export type DTOUserOnboardingJobLevel = z.infer<typeof DTOUserOnboardingJobLevel>;
export type DTOUserSource = z.infer<typeof DTOUserSource>;
export type DTOUserTheme = z.infer<typeof DTOUserTheme>;
export type DTOUserOnboarding = z.infer<typeof DTOUserOnboarding>;
export type DTOAuthenticatedUserProfile = z.infer<typeof DTOAuthenticatedUserProfile>;
export type DTOAuthenticatedUser = z.infer<typeof DTOAuthenticatedUser>;
export type DTOAuthenticatedUserResponse = z.infer<typeof DTOAuthenticatedUserResponse>;
